import { render, staticRenderFns } from "./icon.component.vue?vue&type=template&id=5745810c&scoped=true"
import script from "./icon.component.vue?vue&type=script&lang=ts"
export * from "./icon.component.vue?vue&type=script&lang=ts"
import style0 from "./icon.component.vue?vue&type=style&index=0&id=5745810c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5745810c",
  null
  
)

export default component.exports